export * from './config-lazy-table';
export * from './config-simple-table';
